'use client';

import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent } from './ui/card';
import { createBrowserClientSupa } from '@/utils/supabase/createBrowserClient';
import { CompletedQuiz } from '@/types/CompletedQuiz';
import StatCard from './StatCard';

const QuizzStats = () => {
  const supabase = createBrowserClientSupa();
  const [completedQuizzes, setCompletedQuizzes] = useState<
    CompletedQuiz[] | null
  >(null);

  useEffect(() => {
    async function getCompletedQuizzes() {
      const { data, error } = await supabase
        .from('completed_quizzes')
        .select('*');

      if (error) {
        console.log(error);
        return;
      }
      setCompletedQuizzes(data);
    }
    getCompletedQuizzes();
  }, [supabase]);

  if (!completedQuizzes) {
    return null;
  }

  const numCompletedQuizzes = completedQuizzes?.length;
  const numCorrectAnswers = completedQuizzes?.reduce(
    (acc, quiz) => acc + quiz.num_correct,
    0,
  );
  const numAnswers = completedQuizzes?.reduce(
    (acc, quiz) => acc + quiz.num_questions,
    0,
  );

  const percentCorrect = numAnswers
    ? (numCorrectAnswers / numAnswers) * 100
    : 0;

  return (
    <div className="">
      <Card className="w-full">
        <CardHeader>
          <h2 className="h2 flex items-center gap-2 pb-0!">
            <span>Commitment</span>
          </h2>
        </CardHeader>
        <CardContent>
          <StatCard text={`${numAnswers} questions answered`} variant="info" />
          <StatCard
            text={`${numCompletedQuizzes} quizzes completed`}
            variant="info"
          />
          <StatCard
            text={`${percentCorrect}% correct answers`}
            variant="info"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default QuizzStats;
